import { createTheme } from "@mui/material/styles";

export const enterpriseTokens = {
  navy: "#172033",
  navySoft: "#24324A",
  slate: "#46566F",
  muted: "#71819A",
  line: "#D8E0EA",
  lineSoft: "#E7ECF3",
  surface: "#FFFFFF",
  surfaceAlt: "#F4F7FB",
  surfaceTint: "#EDF4FF",
  primary: "#1D4ED8",
  primaryDark: "#163A9F",
  primarySoft: "#DBEAFE",
  accent: "#0891B2",
  success: "#15803D",
  warning: "#B45309",
  danger: "#B91C1C",
};

export const overviewChartPalette = {
  indigo: "#3157C8",
  teal: "#138A8A",
  cyan: "#2B9BC5",
  violet: "#705CC7",
  amber: "#D79A21",
  coral: "#DE675D",
  navy: "#172033",
  grid: "#E7ECF3",
  track: "#EEF2F7",
};

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: enterpriseTokens.primary,
      dark: enterpriseTokens.primaryDark,
      light: "#60A5FA",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: enterpriseTokens.accent,
      contrastText: "#FFFFFF",
    },
  background: {
      default: "#F4F7FB",
      paper: enterpriseTokens.surface,
    },
    text: {
      primary: enterpriseTokens.navy,
      secondary: enterpriseTokens.muted,
    },
    divider: enterpriseTokens.line,
    success: { main: enterpriseTokens.success },
    warning: { main: enterpriseTokens.warning },
    error: { main: enterpriseTokens.danger },
  },
  typography: {
    fontFamily:
      '"Inter", "Outfit", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontWeight: 650, letterSpacing: 0 },
    h2: { fontWeight: 650, letterSpacing: 0 },
    h3: { fontWeight: 650, letterSpacing: 0 },
    h4: { fontWeight: 650, letterSpacing: 0 },
    h5: { fontWeight: 650, letterSpacing: 0 },
    h6: { fontWeight: 650, letterSpacing: 0 },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: 0,
    },
  },
  shape: {
    borderRadius: 3,
  },
  shadows: [
    "none",
    "0 1px 2px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 8px 24px rgba(15, 23, 42, 0.10)",
    "0 14px 34px rgba(15, 23, 42, 0.12)",
    ...Array(20).fill("0 18px 42px rgba(15, 23, 42, 0.16)"),
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F4F7FB",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: enterpriseTokens.navy,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow: "none",
          minHeight: 34,
          fontSize: 13,
        },
        contained: {
          backgroundColor: enterpriseTokens.primary,
          "&:hover": {
            backgroundColor: enterpriseTokens.primaryDark,
            boxShadow: "none",
          },
        },
        outlined: {
          borderColor: enterpriseTokens.line,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          border: `1px solid ${enterpriseTokens.lineSoft}`,
          boxShadow: "0 18px 42px rgba(15, 23, 42, 0.14)",
          borderRadius: 4,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 14,
          minHeight: 38,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          backgroundColor: "#FFFFFF",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: enterpriseTokens.line,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#94A3B8",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: enterpriseTokens.primary,
            borderWidth: 1,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: enterpriseTokens.slate,
          fontWeight: 700,
          fontSize: 13,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 3,
          border: `1px solid ${enterpriseTokens.lineSoft}`,
          boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 6,
          border: `1px solid ${enterpriseTokens.lineSoft}`,
          boxShadow: "0 24px 64px rgba(15, 23, 42, 0.18)",
        },
      },
    },
  },
});

export default theme;
